<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-patient-room-delete"
      title="Delete User"
      ok-only
      ok-title="Delete"
      @ok="deleteItem"
    >
      <b-card-text>
        <h5>Are You Sure You Want to Remove This Patient Room</h5>
        If you want to remove this Patient Room, click the button below.
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-patient-room-edit"
      ok-only
      centered
      size="lg"
      :title="createMode ? 'Add Patient Room' : 'Edit Patient Room'"
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="4">
            <AutoComplete
              label="Room"
              placeholder="Select Room"
              v-model="EditForm.room_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="available-room"
              text-title="name"
            />
          </b-col>

          <b-col lg="4">
            <b-form-group label="Price" label-for="Price">
              <b-form-input
                id="price"
                type="number"
                v-model="EditForm.price"
                placeholder="Room Price"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Patient Days in Room" label-for="days">
              <b-form-input
                id="days"
                type="number"
                v-model="EditForm.days"
                placeholder="Patient Days in Room"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card>
      <!-- Search Patient Name -->
      <div>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>Patient Rooms</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-patientRoom')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            Create Room
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->

              <!-- Dropdown -->
              <b-dropdown
                variant="link"
                toggle-class="p-0"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  @click="show(data.item)"
                  v-if="
                    $store.state.app.permissions.includes('update-patientRoom')
                  "
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="deleteModel(data.item)"
                  v-if="
                    $store.state.app.permissions.includes('delete-patientRoom')
                  "
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Delete</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Rooms</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getPatientRoomsList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import Datepicker from 'vuejs-datepicker';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import permissionChecker from '@/mixins/permissionChecker';

export default {
  mixins: [permissionChecker],

  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    Datepicker,
  },

  props: ['patientCardId'],

  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      surgeryId: null,
      surgery: {},
      dataCount: 0,
      data: [],
      EditForm: {
        room_id: '',
        patient_card_id: '',
        days: '',
        price: '',
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        room_id: '',
        patient_card_id: '',
        days: '',
        price: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        {
          key: 'room.name',
          label: 'Room Name',
          sortable: true,
        },
        {
          key: 'price',
          label: 'Room Price',
          sortable: true,
        },
        {
          key: 'days',
          label: 'Patient Days in Room',
          sortable: true,
        },

        { key: 'Actions' },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
    };
  },

  mounted() {
    this.getPatientRoomsList();
  },
  methods: {
    show(item, mode) {
      if (mode === 'create') {
        this.surgeryId = null;
        this.createMode = true;
        this.EditForm = {
          patient_card_id: this.patientCardId,
          room_id: '',
          days: '',
          price: '',
          _method: 'POST',
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.patient_card_id = this.patientCardId;
        this.EditForm.room_id = item.room_id;
        this.EditForm.days = item.days;
        this.EditForm.price = item.price;
        this.EditForm._method = 'PUT';
      }
      this.$bvModal.show('modal-patient-room-edit');
    },

    async getPatientRoomsList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `patientRoom?filter[patient_card_id]=${this.patientCardId}&page=${this.page}&take=${this.take}&sort=-id&include=room,patientCard`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-patient-room-delete');
    },
    formatDate(date) {
      if (date) {
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/patientRoom/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientRoomsList();

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.EditForm[item] == '' || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientRoom`),
          this.$store
            .dispatch('create', this.params)
            .then((response) => {
              this.getPatientRoomsList();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientRoom/${this.EditForm.id}`),
          this.$store
            .dispatch('update', this.params)
            .then((response) => {
              this.getPatientRoomsList();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
